export const formName = 'frm_client_terrorist'
export const unsl_ObjectName = 'dbgrd_log_terr'
export const zone_ObjectName = 'dbgrd_log_zone'
export const external_ObjectName = 'dbgrd_aml_external'
export const riskoper_ObjectName = 'dbgrd_aml_risk_oper'
export const alert_ObjectName = 'frm_client_terrorist-dbgrd_alerts'
export const cra_ObjectName = 'dbgrd_sda_log'
export const risk_levels_ObjectName = 'dbgrd_log_risklevels'

export const unsl_instance = 'UNSL'
export const zone_instance = 'zone'
export const external_instance = 'external'
export const risk_oper_instance = 'risk_oper'
export const alert_instance = 'alert'
export const cra_instance = 'cra'
export const risk_levels_instance = 'risklevels'
